import { render, staticRenderFns } from "./sync-sms-mapper.vue?vue&type=template&id=9360d96c&scoped=true"
import script from "./sync-sms-mapper.vue?vue&type=script&lang=js"
export * from "./sync-sms-mapper.vue?vue&type=script&lang=js"
import style0 from "./sync-sms-mapper.vue?vue&type=style&index=0&id=9360d96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9360d96c",
  null
  
)

export default component.exports